import Vue from 'vue'

/** One reactive clock for every real-time cell, so elapsed times and expiry all tick together. */
const clock = Vue.observable({ now: Date.now() })

setInterval(() => {
    clock.now = Date.now()
}, 1000)

export default clock
